import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { stRoomPools } from '../../../services/socialTradingService';

const RESOURCE = Resources.socialTradingPools;

export const poolsDataProvider: CustomDataProvider = {
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== RESOURCE) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const { page = 1, perPage = 10 } = params.pagination || {};
    const limit = perPage;
    const offset = (page - 1) * perPage;
    const res = await stRoomPools({ limit, offset });
    const items = res?.items || [];
    return {
      data: items.map((row) => ({ ...row, id: row.roomId })),
      total: res?.total ?? items.length,
    };
  },
};
